/* Keep each pack link aligned with the native variant selector. */
(() => {
  if (customElements.get('ls-pack-buttons')) return;
  class LoveSuzePackButtons extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-pack-link]'));
      this.members = this.links.map(link => ({ link, variants: JSON.parse(link.dataset.variants) }));
      this.current = this.members.find(member => member.link.dataset.productId === this.dataset.currentId);
      this.notice = this.querySelector('.ls-pack__notice');
      this.selection = this.closest('.product__information')?.querySelector('variant-selection');
      this.onVariant = event => this.update(event.detail.variant?.id);
      this.onClick = event => {
        const link = event.target.closest('[data-pack-link]');
        if (!link || !this.contains(link)) return;
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          this.notice.textContent = 'Choose an available size below to switch to this pack.';
          this.notice.hidden = false;
        }
      };
      this.selection?.addEventListener('variant-change', this.onVariant);
      this.addEventListener('click', this.onClick);
      this.update(this.selection?.getAttribute('variant') || this.dataset.currentVariant);
    }
    disconnectedCallback() {
      this.selection?.removeEventListener('variant-change', this.onVariant);
      this.removeEventListener('click', this.onClick);
    }
    update(variantId) {
      const selected = this.current?.variants.find(variant => String(variant.id) === String(variantId));
      const normalize = value => value.trim().toLowerCase();
      let unavailable = false;
      this.members.forEach(({ link, variants }) => {
        const match = selected && variants.find(variant => normalize(variant.title) === normalize(selected.title));
        const available = Boolean(match?.available);
        if (available || !selected) {
          link.href = available ? `${link.dataset.url}?variant=${encodeURIComponent(match.id)}` : link.dataset.url;
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '0');
          if (!link.classList.contains('is-current')) unavailable = true;
        }
        const display = match || variants.find(variant => variant.available) || variants[0];
        if (display) {
          link.querySelector('[data-pack-price]').innerHTML = display.price;
        }
        link.querySelector('[data-pack-availability]').textContent = available || !selected ? '' : `Unavailable in ${selected.title}`;
      });
      this.notice.hidden = !unavailable;
      this.notice.textContent = selected
        ? 'Some packs are unavailable in this size. Choose another size below to see those options.'
        : 'Choose a size below to see available packs.';
    }
  }
  customElements.define('ls-pack-buttons', LoveSuzePackButtons);
})();
